import { Directive } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { DateService } from "../services/date.service";

@Directive({
    selector: "[DateFormatValidator]",
    providers: [{ provide: NG_VALIDATORS, useExisting: DateFormatValidatorDirective, multi: true }]
})  
export class DateFormatValidatorDirective implements Validator {

  constructor(private dateService: DateService) { }

    validate(control: AbstractControl): ValidationErrors | null {
        if (!!!control.value) {
            return { invalidDateFormat: true, errorMessage: "Please enter a valid date format - mm/dd/yyyy" };
        }

        let dateStr = control.value;
        if (control.value instanceof Date) {
            dateStr = this.dateService.getDateString(control.value);
        }

        if (!this.dateService.isValidDate(dateStr)) {
            return { invalidDateFormat: true, errorMessage: "Please enter a valid date format - mm/dd/yyyy" };
        }

        return null;
    }

}
